(function($) {

    /**
     * SlickSlider enables to initialize the slick slider and refresh it when buttons are added or removed
     */
    $.SlickSlider = function() {
        this._component_name = "slick_slider"; // to be used as name and as a "key" to the configuration
        $.Component.call(this, $.SlickSlider);
        $.on('i18n_language_changed', this._language_changed.bind(this));
    };

    $.Component.create($.SlickSlider, {
        /**
         * Function to be called with the options passed through the main component initialization
         * 
         * @param {*} options 
         */
        _init: function(options) {
            this._options = options || {};
            this._element = this._options.element || "#menu-buttons";
            
            if (typeof(this._element) === 'string') {
                this._element = document.querySelector(this._element);
            }

            this._observer_config = { attributes: false, childList: true, subtree: false };
            var basic_config = {
                slidesToShow: 3,
                slidesToScroll: 3,
                touchThreshold: 20,
                arrows: true,
                infinite: false,
                
                mobileFirst: true,
                variableWidth: false, 
                responsive: [
                    {	
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        }
                    },
                ]
            };
            this._config = this._options.config || basic_config;

            // the module uses MutationObserver to listen when nodes are added or removed dynamically in order to update the slider
            if (this._element && "jQuery" in window && "MutationObserver" in window) {
                this._build_slider();
            }
        },

        _build_slider: function() {
            var $slider = jQuery(this._element);
            $slider.on('init', this._on_init.bind(this));
            $slider.slick(this._config);
        }, 

        _on_init: function() {
            this._slider_mutation_observer = new MutationObserver(this._mutation_callback.bind(this));
            this._slider_mutation_observer.observe(this._element, this._observer_config);
        },

        _mutation_callback: function(mutationsList, observer) {
            observer.disconnect();
            jQuery(this._element).slick('refresh');
            observer.observe(this._element, this._observer_config); 
        },
        
        // refresh slick if language is changed
        _language_changed: function(language) {
            this._slider_mutation_observer.disconnect();
            jQuery(this._element).slick('slickGoTo', 0);
            jQuery(this._element).slick('refresh');
            this._slider_mutation_observer.observe(this._element, this._observer_config); 
        }

    }, $.OSD); 
         
})(ABDOMap);
 